let localStorage;

// block third party cookies check
// https://useloom.atlassian.net/browse/LOOM-1639
try {
  localStorage = window && window.localStorage;
} catch (err) {
  // do nothing
}

const hidePartialInfoSavedKey = 'engagementInsights:showPartialInfoSaved';

export const hidePartialInfo = () =>
  localStorage && localStorage.setItem(hidePartialInfoSavedKey, true);
export const getHidePartialInfoStored = () =>
  localStorage && localStorage.getItem(hidePartialInfoSavedKey);
